import * as React from 'react'

import { TQAddonDetailVariables, useQAddonDetail } from '~graphql/generated/clientGraphql'

import { useProductDetailCtx } from '../../ProductDetail'

type TOptions = {
  branchId: ID
  addonId: Nullable<ID>
}

/**
 * Loads additional data needed to render MAIN addon detail.
 */
export const useLoadAddonDetail = ({ branchId, addonId }: TOptions) => {
  const { product } = useProductDetailCtx()

  const variables = React.useMemo<TQAddonDetailVariables | undefined>(() => {
    if (!addonId || !product) return undefined
    const isCombinationMeal = product.isCombinationMeal

    return { branchId, productId: addonId, isCombinationMeal }
  }, [addonId, branchId, product])

  const { data, loading, error } = useQAddonDetail({
    variables,
    skip: !variables,
  })

  if (loading) {
    return {
      loading,
      addonDetail: null,
    }
  }

  if (!data || error) {
    return { addonDetail: null, loading, error }
  }

  return { addonDetail: data.product, loading }
}
